// src/utils/axiosInstance.js

import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://homeleadiq.com/api',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 5000,
});

// ✅ Request Interceptor: Add JWT and check expiration
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        if (decoded?.exp && decoded.exp * 1000 < Date.now()) {
          console.warn('JWT expired. Removing and redirecting.');
          localStorage.removeItem('token');
          // Don't alert during requests — let response handler handle it
        } else {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (err) {
        console.error('JWT decode error:', err);
        localStorage.removeItem('token');
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 🔁 Optional: Handle token refresh if using refresh tokens
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(p => (token ? p.resolve(token) : p.reject(error)));
  failedQueue = [];
};

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // 🔒 Temporarily disable refresh-token logic
    if (error.response?.status === 401 && !originalRequest._retry) {
      /*
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return axiosInstance(originalRequest);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const { data } = await axios.post(
          `${axiosInstance.defaults.baseURL}/refresh-token`,
          { refreshToken: localStorage.getItem('refreshToken') }
        );
        localStorage.setItem('token', data.token);
        axiosInstance.defaults.headers.Authorization = `Bearer ${data.token}`;
        processQueue(null, data.token);
        return axiosInstance(originalRequest);
      } catch (err) {
        processQueue(err, null);
        localStorage.removeItem('token');
        alert("Session expired. Please log in again.");
        window.location.href = '/';
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
      */
      localStorage.removeItem('token');
      alert("Session expired. Please log in again.");
      window.location.href = '/';
      return Promise.reject(error);
    }

    // Log and rethrow other errors
    if (error.response) {
      console.error('API Response Error:', error.response);
    } else {
      console.error('Network Error:', error);
    }

    return Promise.reject(error.response?.data?.message || 'Unexpected error occurred');
  }
);

export default axiosInstance;